import type { ReactNode } from 'react';
import { styled } from 'styled-components';
import { DropdownMenuLabel } from '@radix-ui/react-dropdown-menu';
import { Heading } from '../Heading';

export type MenuLabelProps = {
  /**
   * The text of the label
   */
  children: ReactNode | string;
};

const StyledMenuLabel = styled(DropdownMenuLabel)`
  padding: var(--wui-space-02);
`;

export const MenuLabel = ({ children, ...props }: MenuLabelProps) => {
  return (
    <StyledMenuLabel
      asChild={true}
      {...props}
    >
      <Heading
        renderAs="span"
        variant="heading6"
        {...props}
      >
        {children}
      </Heading>
    </StyledMenuLabel>
  );
};

MenuLabel.displayName = 'MenuLabel';
